import * as React from 'react';

import { Icon } from '@rbilabs/components-library';
import styled from 'styled-components';

import UnstyledButton from '../unstyled-button';

import theme from './theme';

const StyledButton = styled(UnstyledButton)`
  border-bottom: 1px solid ${theme.arrowButtonBorderBottom};
  background-color: transparent;
  width: 100%;
  font-family: ${Styles.fontFamily.body};
  text-decoration: none;
  color: ${theme.arrowButtonColor};
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
`;

export const ArrowButton: React.FC<React.ComponentProps<typeof StyledButton>> = ({
  children,
  ...props
}) => (
  <StyledButton {...props}>
    {children}
    <Icon icon="next" color="icon-default" width="16px" aria-hidden />
  </StyledButton>
);
